import WildAppResource from "./WildAppResource";
import OrderAppResource from "./OrderAppResource";

class InvitationAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'invitation';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'invitations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'category',
            'token',
            'token_expires_at',
            'accepted_at',
            'meta',
            'orderUuid'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            order: OrderAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            orderUuid: 'order_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            'meta.primarySeller.email': {
                type: 'string',
                email: true,
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            'meta.primarySeller.phone': {
                type: 'string',
                presence: false,
                format: {
                    pattern: '^([0-9-. \(\)\+]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            'meta.secondarySeller.email': {
                type: 'string',
                email: true,
                presence: false,
                length: {
                    maximum: 255,
                },
            },
            'meta.secondarySeller.phone': {
                type: 'string',
                presence: false,
                format: {
                    pattern: '^([0-9-. \(\)\+]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default InvitationAppResource;
